import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function StaffJoinPage() {
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setError("Ссылка недействительна"); return; }
    axios.get(`${API}/team/invite/${token}`)
      .then((r) => setInfo(r.data))
      .catch(() => setError("Приглашение не найдено или истекло. Попросите владельца отправить новое."));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const r = await axios.post(`${API}/team/invite/accept`, { token, code: code.trim(), password });
      localStorage.setItem("token", r.data.access_token);
      localStorage.setItem("user", JSON.stringify(r.data.user));
      window.location.href = "/staff";
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Не удалось принять приглашение");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-gray-50 text-black flex items-center justify-center p-4">
      <div className="bg-white border-4 border-black rounded-lg p-8 w-full max-w-md" data-testid="staff-join-card">
        <img src="/logo-header.png" alt="Chatity" className="h-6 w-auto mb-3" data-testid="staff-join-logo-img" />
        <h1 className="text-2xl font-bold mb-1">Приглашение в команду</h1>
        {info && (
          <p className="text-sm text-gray-600 mb-6">
            {info.staff_name ? `${info.staff_name}, вас` : "Вас"} пригласили в «<b>{info.salon_name}</b>» как{" "}
            <b>{info.role === "admin" ? "администратора" : "мастера"}</b> ({info.email})
          </p>
        )}
        {error && <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded p-3 mb-4" data-testid="staff-join-error">{error}</p>}
        {info && (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label>Одноразовый код из письма</Label>
              <Input data-testid="staff-join-code-input" value={code} onChange={(e) => setCode(e.target.value)}
                placeholder="123456" maxLength={6} inputMode="numeric"
                className="border-2 border-black text-center text-2xl tracking-[0.4em] font-bold h-14" />
            </div>
            <div>
              <Label>Придумайте пароль</Label>
              <Input data-testid="staff-join-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="Минимум 6 символов" className="border-2 border-black" />
            </div>
            <Button data-testid="staff-join-submit-btn" type="submit" disabled={busy || code.length < 6 || password.length < 6}
              className="w-full bg-black text-white font-bold h-12 hover:bg-gray-800">
              {busy ? "Подождите..." : "Присоединиться"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
